import React, { useState } from "react";
import {
  TextField,
  Typography,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";

const InputData = ({
  label,
  placeholder,
  type = "text",
  multiline = false,
  rows = 1,
  isDropdown = false,
  itemsDropdown = [],
  value,
  onChange,
  disabled = false,
  fullWidth = true,
  sx = {},
  ...props
}) => {
  const [open, setOpen] = useState(false);

  if (isDropdown) {
    return (
      <FormControl fullWidth={fullWidth} sx={{ mb: 2, ...sx }}>
        <InputLabel>{label}</InputLabel>
        <Select
          label={label}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          value={value}
          onChange={onChange}
          disabled={disabled}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
              },
            },
          }}
        >
          {itemsDropdown.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Box sx={{ mb: 2, ...sx }}>
      {label && (
        <Typography variant="body1" gutterBottom>
          {label}
        </Typography>
      )}
      <TextField
        placeholder={placeholder}
        type={type}
        multiline={multiline}
        rows={rows}
        value={value}
        onChange={onChange}
        disabled={disabled}
        fullWidth={fullWidth}
        variant="outlined"
        {...props}
      />
    </Box>
  );
};

export default InputData;
